export default __webpack_public_path__ + "static/media/icon_chevron.77adfa8f.svg";